import { AccountInfo } from '@azure/msal-browser';
import { UserData } from '../models/navigation';

/**
 * Extracts user data from Azure B2C account information
 * @param account - The MSAL account object from Azure B2C
 * @returns UserData object with user information
 */
export const getUserFromAccount = (account: AccountInfo | null): UserData | null => {
  if (!account) {
    return null;
  }

  // Extract name from idTokenClaims
  const name = account.idTokenClaims?.name || 
               account.idTokenClaims?.given_name || 
               account.name || 
               account.username || 
               'Unknown User';

  // Extract email
  const email = account.idTokenClaims?.emails?.[0] || 
                account.idTokenClaims?.email || 
                account.username || 
                '';

  return {
    id: account.homeAccountId || account.localAccountId || '',
    name: name as string,
    email: email as string,
  };
};

/**
 * Generates user initials from the full name
 * @param name - Full name of the user
 * @returns Initials (first letter of first name and last name)
 */
export const getUserInitials = (name: string): string => {
  if (!name || name.trim() === '') {
    return 'U'; // Default for unknown user
  }

  const nameParts = name.trim().split(' ').filter(part => part.length > 0);
  
  if (nameParts.length === 0) {
    return 'U';
  } else if (nameParts.length === 1) {
    // Single name - return first letter
    return nameParts[0][0].toUpperCase();
  } else {
    // Multiple names - return first letter of first and last name
    return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
  }
};
